var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79688 22.1719H3.60938M3.60938 22.1719C3.60938 22.1719 8.76562 29.3906 16.5 29.3906C23.6197 29.3906 29.3906 24.2344 29.3906 18.0469M3.60938 22.1719V29.3906M23.2031 10.8281H29.3906M29.3906 10.8281C29.3906 10.8281 24.2344 3.60938 16.5 3.60938C9.38025 3.60938 3.60938 8.76562 3.60938 14.9531M29.3906 10.8281V3.60938",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.2f68cceaa98dbcbc4b474a07ea64cb45.svg";
export { ForwardRef as ReactComponent };